<script lang="ts" setup>
import ReplyInput, {
  ReplyInputInstance,
} from "@/components/mobile/reply/ReplyInput.vue";
import { ref } from "vue";
import ReplyList from "@/components/mobile/reply/ReplyList.vue";
import MomentActions from "@/components/mobile/popup/MomentActions.vue";
import { useRouter } from "vue-router";
import { CoinRank } from "@/types/coinRank";
import { getRankServerDtStart } from "@/composable/rank";
import { Reply } from "@/types/entity";

const props = withDefaults(
  defineProps<{
    showInput: boolean;
    rank: CoinRank;
  }>(),
  {
    showInput: true,
  }
);
const router = useRouter();

const replyTarget = ref<Reply | null>(props.rank.reply); // 底部输入框的回复目标
const replyInputRef = ref<ReplyInputInstance | null>(null);
const toOperateReply = ref<Reply | null>(null);
const showActions = ref(false);

const onReplyLoaded = (reply: Reply) => {
  replyTarget.value = reply;
};

const onReplyBtnClick = (replay: Reply) => {
  replyTarget.value = replay;
  replyInputRef.value?.focus();
};
const onReplyActionClick = (reply: Reply) => {
  toOperateReply.value = reply;
  showActions.value = true;
};
</script>
<template>
  <div class="w-full h-full grid grid-rows-[auto_1fr_auto]">
    <div class="h-full overflow-y-auto pb-16">
      <rank-banner
        :coin-rank="rank"
        :dt-start="getRankServerDtStart(rank.dtStart)"
      />
      <div class="text-lg px-4 pt-4">
        {{ $t("rank.comments") }}({{ rank.reply?.replyCount ?? 0 }})
      </div>
      <div class="p-4">
        <reply-list
          :root-id="rank.replyId"
          @on-reply-click="onReplyBtnClick"
          @on-reaction-click="onReplyActionClick"
          @on-loaded="onReplyLoaded"
        />
      </div>
    </div>
    <Teleport to="#main-view">
      <div v-if="showInput" class="absolute bottom-0 left-0 w-full">
        <reply-input
          ref="replyInputRef"
          :reply-target="replyTarget"
          :show-tip="rank.replyId !== replyTarget?.id"
          @reply-aborted="replyTarget = rank.reply"
        />
      </div>
    </Teleport>

    <moment-actions
      v-model:show="showActions"
      :reply="toOperateReply"
      @after-delete="router.back()"
    />
  </div>
</template>
